import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { authFetch } from "../utils/authFetch";

function Paymode() {
  const [paymodeForm, setPaymodeForm] = useState({ name: "", status: true });
  const [paymodes, setPaymodes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const showToast = (message, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      positionClass: "toast-top-right",
      timeOut: "3000",
    };
    toastr[type](message);
  };

  const fetchPaymodes = async () => {
    try {
      const res = await authFetch("/api/v1/paymode/list");
      if (!res) return; // authFetch will redirect if 401

      const data = await res.json();
      setPaymodes(Array.isArray(data) ? data : []);
    } catch {
      showToast("Failed to fetch paymodes", "error");
    }
  };

  useEffect(() => {
    fetchPaymodes();
  }, []);

  const handleCreateOrUpdate = async () => {
    if (!paymodeForm.name.trim()) {
      showToast("Name is required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/paymode/update"
      : "/api/v1/paymode/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        body: JSON.stringify({
          ...paymodeForm,
          id: editingId,
        }),
      });
      if (!res) return;

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "Paymode updated" : "Paymode created", editingId ? "info" : "success");
      setPaymodeForm({ name: "", status: true });
      setEditingId(null);
      fetchPaymodes();
      document.querySelector("#paymodeModal .btn-close")?.click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (pm) => {
    setPaymodeForm({ name: pm.name, status: pm.status });
    setEditingId(pm.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this paymode?")) return;

    try {
      const res = await authFetch(`/api/v1/paymode/delete/${id}`, {
        method: "DELETE",
      });
      if (!res) return;

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("Paymode deleted", "error");
      fetchPaymodes();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPaymodeForm({
      ...paymodeForm,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  return (
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <div className="card-title d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Paymode Manager</h4>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#paymodeModal"
                  onClick={() => {
                    setPaymodeForm({ name: "", status: true });
                    setEditingId(null);
                  }}
                >
                  Add Paymode
                </button>
              </div>

              {/* Modal */}
              <div className="modal fade" id="paymodeModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{editingId ? "Edit Paymode" : "Add Paymode"}</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <input
                        name="name"
                        placeholder="Paymode Name"
                        className="form-control mb-2"
                        value={paymodeForm.name}
                        onChange={handleChange}
                      />
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name="status"
                          className="form-check-input"
                          checked={paymodeForm.status}
                          onChange={handleChange}
                        />
                        <label className="form-check-label">Active</label>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button className="btn btn-primary" onClick={handleCreateOrUpdate} disabled={loading}>
                        {loading ? "Saving..." : editingId ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <hr />
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymodes.length === 0 && (
                      <tr>
                        <td colSpan="3" className="text-center">No Paymodes found</td>
                      </tr>
                    )}
                    {paymodes.map((pm,i) => (
                      <tr key={pm.id}>
                        <td>{i + 1}</td> 
                        <td>{pm.name}</td>
                        <td>{pm.status ? "Active" : "Inactive"}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info me-2"
                            data-bs-toggle="modal"
                            data-bs-target="#paymodeModal"
                            onClick={() => handleEdit(pm)}
                          >
                            <span class="bx bx-edit"></span>
                          </button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => handleDelete(pm.id)}>
                            <span class="bx bx-trash"></span>
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Paymode;
